import { render } from "./CreationStyle.vue?vue&type=template&id=ef5c0c20&scoped=true"
import script from "./CreationStyle.vue?vue&type=script&lang=js"
export * from "./CreationStyle.vue?vue&type=script&lang=js"

import "./CreationStyle.vue?vue&type=style&index=0&id=ef5c0c20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5c0c20"]])

export default __exports__